// extracted by mini-css-extract-plugin
export default {"tooltip":"wQ-z","arrow":"xQ-z"};